import React from 'react';
import {Button} from 'react-bootstrap';

interface Props {
    className?: string;
    onClick?: () => void;
    children?: React.ReactNode;
    danger?: boolean;
}

function OutlinedButton(props: Readonly<Props>) {
    let className = 'btn-outline ';
    className += props.danger ? ' danger ' : ''
    className += props.className ?? '';
    return (
        <Button className={className}
                onClick={props.onClick}>
            {props.children}
        </Button>
    );
}

export default OutlinedButton;
